import { exportTableToPdf } from '../exportTableToPdf';
import { getRaidPdfCellStyle, RAID_BADGE_COLUMNS } from '../pdfCellStyles';
import {
    filterRowsByIds,
    formatPdfDateTime,
    formatPlainText,
    getVisibleColumnsFromOrder,
} from '../pdfTextUtils';

export const RAID_COLUMN_LABELS = {
    raidItem: 'RAID Item',
    category: 'Category',
    impact: 'Impact',
    level: 'Level',
    probability: 'Probability',
    proximity: 'Proximity',
    owner: 'Owner',
    strategy: 'Strategy / Mitigation',
    rag: 'RAG',
    loggedOn: 'Logged on',
    updatedOn: 'Updated on',
    status: 'Status',
};

const COLUMN_WEIGHTS = {
    raidItem: 3.2,
    category: 1.1,
    impact: 1.5,
    level: 1,
    probability: 1,
    proximity: 1,
    owner: 1.2,
    strategy: 2,
    rag: 0.9,
    loggedOn: 1.2,
    updatedOn: 1.2,
    status: 1.1,
};

const CATEGORY_LABELS = { RISK: 'Risk', ASSUMPTION: 'Assumption', ISSUE: 'Issue', DEPENDENCY: 'Dependency' };
const LEVEL_LABELS = { NEGLIGIBLE: 'Negligible', LOW: 'Low', MODERATE: 'Moderate', HIGH: 'High', CRITICAL: 'Critical' };
const PROB_LABELS = { HIGH: 'High', MEDIUM: 'Medium', LOW: 'Low' };
const PROX_LABELS = { '0-1': '0 - 1 mo', '1-3': '1 - 3 mo', '3-12': '3 - 12 mo', '12+': '12+ mo' };
const RAG_LABELS = { RED: 'Red', AMBER: 'Amber', GREEN: 'Green' };
const STATUS_LABELS = {
    NOT_STARTED: 'Not Started',
    WORKING_ON_IT: 'Working on it',
    COMPLETED: 'Completed',
    STUCK: 'Stuck',
    CANCELLED: 'Cancelled',
};

const getCellValue = (row, columnKey) => {
    switch (columnKey) {
        case 'raidItem':
            return formatPlainText(row.raid_item || '');
        case 'category':
            return CATEGORY_LABELS[row.raid_category] || row.raid_category || '';
        case 'impact':
            return formatPlainText(row.impact || '');
        case 'level':
            return LEVEL_LABELS[row.level] || row.level || '';
        case 'probability':
            return PROB_LABELS[row.probability] || row.probability || '';
        case 'proximity':
            return PROX_LABELS[row.proximity] || row.proximity || '';
        case 'owner':
            return formatPlainText(row.owner || '');
        case 'strategy':
            return formatPlainText(row.strategy || '');
        case 'rag':
            return RAG_LABELS[row.rag] || row.rag || '';
        case 'loggedOn':
            return row.created ? formatPdfDateTime(row.created) : '';
        case 'updatedOn':
            return row.last_updated ? formatPdfDateTime(row.last_updated) : '';
        case 'status':
            return STATUS_LABELS[row.status] || row.status || '';
        default:
            return '';
    }
};

export const exportRaidToPdf = async ({
    rows,
    groupedSections = null,
    columnOrder,
    isColumnVisible,
    projectName,
    selectedRowIds = null,
    filename = 'raid_items.pdf',
}) => {
    const visibleColumns = getVisibleColumnsFromOrder(columnOrder, RAID_COLUMN_LABELS, isColumnVisible);
    const filteredRows = filterRowsByIds(rows, selectedRowIds);

    const sections = groupedSections?.length
        ? groupedSections.map(section => ({
              title: `${section.groupName} (${section.items?.length || 0})`,
              rows: filterRowsByIds(section.items, selectedRowIds),
          }))
        : null;

    await exportTableToPdf({
        title: 'RAID',
        projectName,
        visibleColumns,
        rows: sections ? [] : filteredRows,
        groupedSections: sections,
        getCellValue,
        getCellStyle: (row, columnKey) => getRaidPdfCellStyle(columnKey, row),
        columnWeights: COLUMN_WEIGHTS,
        badgeColumns: RAID_BADGE_COLUMNS,
        filename,
    });
};
